import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthDataDispatcher } from './auth-data.dispatcher';
import { AuthDataStore } from './auth-data.store';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private _authDataStore: AuthDataStore,
    private _authDataDispatcher: AuthDataDispatcher
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    let url: string = state.url;

    return this.checkAuthenticated(url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }

  checkAuthenticated(url: string): Observable<boolean> {
    return this._authDataStore.isAuthenticated().pipe(
      tap((authenticated: boolean) => {
        // Navigate to the login page if not authenticated
        if (!authenticated) {
          this._authDataDispatcher.logout(true, url);
        }
      })
    );
  }
}
